module.exports = __webpack_public_path__ + "static/img/shake_titleimg.f092fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shake_titleimg.png
// module id = +TDt
// module chunks = 1